<template>
    <div>
        <div class="c_table_wrap marginB15">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">프로필 이미지 설정</td>
                    <td>
                        <div class="d_block" @click="changeType('profile')">
                            <el-upload
                                class="avatar-uploader"
                                action=""
                                list-type="picture-card"
                                :auto-upload="false"
                                :show-file-list="false"
                                :file-list="profile"
                                :on-change="onlyOnePhotoChange"
                                style="display: inline-block"
                            >
                                <i class="el-icon-plus avatar-uploader-icon"
                                   v-if="profile.length === 0"></i>
                                <div v-else>
                                    <img :src="profile[0].url" alt="" class="avatar">
                                </div>
                                <div class="el-upload__tip" style="font-size:14px; color:red;"
                                     slot="tip">권장이미지 : 140px * 140px
                                </div>
                            </el-upload>
                        </div>
                    </td>
                    <td class="c_t_title">프로필 소개</td>
                    <td>
                        <div class="d_block intro_textarea">
                            <el-input v-model="mb_introduce" @input="parentChange('mb_introduce', mb_introduce)" type="textarea" style="width: 100%; height: 150px;" resize="none" placeholder="프로필에 소개글을 작성해주세요." show-word-limit maxlength="60"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_introduce') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">아이디</td>
                    <td colspan="3">
                        <div v-if="returnMemberType()">
                            <el-input v-model="mb_id" @input="initIdCheck('mb_id', mb_id)"
                                      @blur="checkIdDouble('mb_id', mb_id)"></el-input>
                            <div class="input_error" v-if="validation.hasError('mb_id')">
                                {{ validation.firstError('mb_id') }}
                            </div>
                            <div class="input_error" v-else-if="validation.hasError('idDoubleCheck')">
                                {{ validation.firstError('idDoubleCheck') }}
                            </div>
                            <div class="input_error" v-else-if="idDoubleCheck">사용가능한 아이디입니다.</div>
                        </div>
                        <div v-else>
                            {{ memberData.mb_id }}
                        </div>
                    </td>
<!--                    <td class="c_t_title">이름</td>
                    <td>
                        <div>
                            <el-input v-model="mb_name" @input="parentChange('mb_name', mb_name)"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_name') }}</div>
                        </div>
                    </td>-->
                </tr>
                <tr>
                    <td class="c_t_title">닉네임</td>
                    <td>
                        <div>
                            <el-input v-model="mb_nick" @input="initNickCheck('mb_nick', mb_nick)"
                                      @blur="checkNickDouble('mb_nick', mb_nick)"></el-input>
                            <div class="input_error" v-if="validation.hasError('mb_nick')">
                                {{ validation.firstError('mb_nick') }}
                            </div>
                            <div class="input_error" v-else-if="validation.hasError('nickDoubleCheck')">
                                {{ validation.firstError('nickDoubleCheck') }}
                            </div>
                            <div class="input_error" v-else-if="nickDoubleCheck">사용가능한 닉네임입니다.</div>
                        </div>
                    </td>
                    <td class="c_t_title">성별</td>
                    <td>
                        <div>
                            <el-select
                                v-model="mb_sex"
                                @change="changeSex()"
                                :disabled="hasMemberData()"
                                placeholder="선택"
                            >
                                <el-option
                                    v-for="(data, index) in arSex"
                                    :key="index"
                                    :label="data.label"
                                    :value="data.value"
                                >
                                </el-option>
                            </el-select>
                            <div class="input_error">{{ validation.firstError('mb_sex') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">생년월일</td>
                    <td>
                        <div>
                            <el-date-picker
                                v-model="mb_birth"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="YYYY-MM-DD"
                                @change="parentChange('mb_birth', mb_birth)"
                            >
                           </el-date-picker>
                            <div class="input_error">{{ validation.firstError('mb_birth') }}</div>
                        </div>
                    </td>

                    <!-- <td class="c_t_title">연령</td>
                    <td>
                        <div>
                            <el-input v-model="mb_age" @change="parentChange('mb_age', mb_age)"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_age') }}</div>
                        </div>
                    </td> -->
                    <td class="c_t_title">회원등급</td>
                    <td>
                        <div>
                            <el-select
                                v-model="mb_is_testor"
                                @change="parentChange('mb_is_testor', mb_is_testor)"
                            >
                                <el-option
                                    v-for="(data, index) in arTester"
                                    :key="index"
                                    :label="data.label"
                                    :value="data.value"
                                >
                                </el-option>
                            </el-select>
                            <div class="input_error">{{ validation.firstError('mb_is_testor') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">키</td>
                    <td>
                        <div>
                            <el-input v-model="mb_height" @change="parentChange('mb_height', mb_height)"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_height') }}</div>
                        </div>
                    </td>
                    <td class="c_t_title">몸무게</td>
                    <td>
                        <div>
                            <el-input v-model="mb_weight" @change="parentChange('mb_weight', mb_weight)"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_weight') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">{{ memberData.mb_no ? ' 새 ' : '' }}비밀번호</td>
                    <td>
                        <div class="d_block">
                            <el-input type="password" v-model="mb_password"
                                      @change="parentChange('mb_password', mb_password)"
                                      :placeholder="`${memberData.mb_no ? '새 ' : ''}비밀번호를 입력해주세요.`"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_password') }}</div>
                        </div>
                    </td>
                    <td class="c_t_title">{{ memberData.mb_no ? ' 새 ' : '' }}비밀번호 확인</td>
                    <td>
                        <div class="d_block">
                            <el-input type="password" v-model="mb_password_chk"
                                      @change="parentChange('mb_password_chk', mb_password_chk)"
                                      :placeholder="`${memberData.mb_no ? '새 ' : ''}비밀번호 다시 입력해주세요.`"></el-input>
                            <div class="input_error">{{ validation.firstError('mb_password_chk') }}
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="title marginT15">
            기타
            <div class="clear"></div>
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">Outer 구매금액</td>
                    <td>
                        <el-select
                            v-model="mb_part.outer"
                            @change="parentChange('mb_part', mb_part)"
                        >
                            <el-option
                                v-for="(item, index) in priceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">선호하는컬러 1(필수)</td>
                    <td>
                        <div>
                            <el-select
                                v-model="mb_color[0]"
                                @change="parentChange('mb_color', mb_color)"
                            >
                                <el-option
                                    v-for="(item, index) in colorList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.value"
                                    :disabled="pickedColor(item)"
                                >
                                </el-option>
                            </el-select>
                            <div class="input_error" v-show="validation.hasError('mb_color')">
                                {{ validation.firstError('mb_color') }}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">Top 구매금액</td>
                    <td>
                        <el-select
                            v-model="mb_part.top"
                            @change="parentChange('mb_part', mb_part)"
                        >
                            <el-option
                                v-for="(item, index) in priceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">선호하는컬러 2(선택)</td>
                    <td>
                        <el-select
                            v-model="mb_color[1]"
                            :disabled="!hasValue(1)"
                            @change="noneColor()"
                        >
                            <el-option :value="''" :label="'선택'"></el-option>
                            <el-option
                                v-for="(item, index) in colorList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                                :disabled="pickedColor(item)"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">Inner 구매금액</td>
                    <td>
                        <el-select
                            v-model="mb_part.inner"
                            @change="parentChange('mb_part', mb_part)"
                        >
                            <el-option
                                v-for="(item, index) in priceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">선호하는컬러 3(선택)</td>
                    <td>
                        <el-select
                            v-model="mb_color[2]"
                            :disabled="!hasValue(2)"
                            @change="noneColor()"
                        >
                            <el-option :value="''" :label="'선택'"></el-option>
                            <el-option
                                v-for="(item, index) in colorList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                                :disabled="pickedColor(item)"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">Pants 구매금액</td>
                    <td>
                        <el-select
                            v-model="mb_part.pants"
                            @change="parentChange('mb_part', mb_part)"
                        >
                            <el-option
                                v-for="(item, index) in priceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">어깨 착용감</td>
                    <td>
                        <el-select
                            v-model="mb_mat_shoulder"
                            @change="parentChange('mb_mat_shoulder', mb_mat_shoulder)"
                        >
                            <el-option
                                v-for="(item, index) in matValueList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">Shoes 구매금액</td>
                    <td>
                        <el-select
                            v-model="mb_part.shoes"
                            @change="parentChange('mb_part', mb_part)"
                        >
                            <el-option
                                v-for="(item, index) in priceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">
                        {{ mb_sex === 1 ? '허리' : '가슴' }} 착용감
                    </td>
                    <td>
                        <el-select
                            v-model="mb_mat_top"
                            @change="parentChange('mb_mat_top', mb_mat_top)"
                        >
                            <el-option
                                v-for="(item, index) in matValueList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">Acc 구매금액</td>
                    <td>
                        <el-select
                            v-model="mb_part.acc"
                            @change="parentChange('mb_part', mb_part)"
                        >
                            <el-option
                                v-for="(item, index) in priceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">배 착용감</td>
                    <td>
                        <el-select
                            v-model="mb_mat_middle"
                            @change="parentChange('mb_mat_middle', mb_mat_middle)"
                        >
                            <el-option
                                v-for="(item, index) in matValueList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">피부톤</td>
                    <td>
                        <el-select
                            v-model="mb_skin"
                            @change="parentChange('mb_skin', mb_skin)"
                        >
                            <el-option
                                v-for="(item, index) in skinList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">
                        {{ mb_sex === 1 ? '허벅지' : '허리' }} 착용감
                    </td>
                    <td>
                        <el-select
                            v-model="mb_mat_bottom"
                            @change="parentChange('mb_mat_bottom', mb_mat_bottom)"
                        >
                            <el-option
                                v-for="(item, index) in matValueList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">얼굴형</td>
                    <td>
                        <el-select
                            v-model="mb_face"
                            @change="parentChange('mb_face', mb_face)"
                        >
                            <el-option
                                v-for="(item, index) in faceList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                    <td class="c_t_title">체형</td>
                    <td>
                        <el-select
                            v-model="mb_body"
                            @change="parentChange('mb_body', mb_body)"
                        >
                            <el-option
                                v-for="(item, index) in bodyList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">직종</td>
                    <td>
                        <el-select
                            v-model="mb_job"
                            @change="parentChange('mb_job', mb_job)"
                        >
                            <el-option
                                v-for="(item, index) in jobList"
                                :key="index"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <div v-if="mb_job === 1">
                            <el-input type="text" v-model="mb_job_extra"
                                      @change="parentChange('mb_job_extra', mb_job_extra)"
                                      v-show="mb_job === 1"></el-input>
                            <div class="input_error" v-show="mb_job === 1">
                                {{ validation.firstError('mb_job_extra') }}
                            </div>
                        </div>
                    </td>
                    <td class="c_t_title" v-if="!returnMemberType()">얼굴 사진 등록 여부</td>
                    <td>
                        <div class="pl15">{{isAddFaceFile() ? 'O' : 'X'}}</div>
                    </td>
                </tr>
            </table>
        </div>

        <div v-if="!returnMemberType()">
            <div class="title marginT15">
                주문 정보
                <div class="clear"></div>
            </div>
            <div class="c_table_wrap">
                <table>
                    <colgroup>
                        <col width="200px;">
                        <col width="">
                        <col width="200px;">
                        <col width="">
                    </colgroup>
                    <tr>
                        <td class="c_t_title">주문자명</td>
                        <td>
                            <div>
                                <el-input v-model="order_mb_name" @input="parentChange('order_mb_name', order_mb_name)"></el-input>
                                <div class="input_error">{{ validation.firstError('order_mb_name') }}</div>
                            </div>
                        </td>
                        <td class="c_t_title">주문자 전화번호</td>
                        <td>
                            <div>
                                <el-input v-model="order_mb_hp" @input="parentChange('order_mb_hp', order_mb_hp)"></el-input>
                                <div class="input_error">{{ validation.firstError('order_mb_hp') }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <delivery-list-member-component :memberKey="memberKey" v-if="!returnMemberType()"></delivery-list-member-component>

        <div class="title marginT15">
            상담 기록
            <div class="clear"></div>
        </div>
        <div class="d_block">
            <el-input v-model="mb_memo" @change="parentChange('mb_memo', mb_memo)" type="textarea"
                      style="width: 100%; height: 130px;" resize="none"></el-input>
            <div class="input_error">{{ validation.firstError('mb_memo') }}</div>
        </div>
        <div class="text_center mt15" v-if="!returnMemberType()">
            <el-button @click="submitForm()" type="primary">저장</el-button>
            <el-button type="danger" @click="openModal('member-out-modal')" v-if="memberData.mb_no && hasQuit()">회원탈퇴
            </el-button>
            <el-button type="info" @click="openModal('member-stop-modal')" v-if="isStopUser === 0">사용자 이용중지</el-button>
            <el-button type="info" plain @click="openModal('member-active-modal')" v-else>이용중지 해제</el-button>
        </div>
        <member-out-modal :getObj="{mb_no : this.memberData.mb_no}"></member-out-modal>
        <member-stop-modal :getObj="{mb_no : this.memberData.mb_no}" :afterFunc="memberStopAfter"></member-stop-modal>
        <member-active-modal :getObj="{mb_no : this.memberData.mb_no}"
                             :afterFunc="memberActiveAfter"></member-active-modal>
    </div>
</template>

<script>
import MemberValidator from "@/mixins/validators/MemberValidator";
import elFileMixins from "@/mixins/elFileMixins";
import util from "@/mixins/util";
import {mapState} from "vuex";

import {
    authPriceValues,
    authFaceValues,
    authSkinValues,
    authJobValues,
    authColorValues,
    returnMatValues,
    authBodyValues
} from "@/service/authService";
import EventBus from "@/mixins/event-bus";
import MemberOutModal from "@/components/modal/MemberOutModal";
import MemberStopModal from "@/components/modal/MemberStopModal";
import MemberActiveModal from "@/components/modal/MemberActiveModal";
import DeliveryListMemberComponent from "@/components/delivery/DeliveryListMemberComponent.vue"

export default {
    name: "MemberWriteDefaultLayout",
    mixins: [MemberValidator, elFileMixins],
    components: {MemberActiveModal, MemberStopModal, MemberOutModal, DeliveryListMemberComponent},
    inject: ['memberWriteSetData'],
    provide() {
        return {}
    },
    props: {
        memberData: {
            default: () => {
            }
        },
        orderInfoData: {
            default: () => {
            }
        },
        memberKey: {default: 0},
    },
    data() {
        return {
            arSex: [
                {
                    label: '남자',
                    value: 0
                },
                {
                    label: '여자',
                    value: 1
                }
            ],

            arTester: [
                {
                    label: '일반',
                    value: 0
                },
                {
                    label: '테스터',
                    value: 1
                }
            ],

            priceList: authPriceValues,
            faceList: authFaceValues,
            jobList: authJobValues,
            colorList: authColorValues,
            skinList: authSkinValues,
            matValueList: returnMatValues('mypage'),
            bodyList: authBodyValues(0),

            isStopUser: 0, // 1 일경우 이용 제한 회원
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        if (this.hasMemberData()) {
            this.setInitData();
        }
        if (this.hasMemberOrderInfoData()) {
            this.setInitOrderInfoData();
        }
        EventBus.$on('MemberWriteDefaultLayoutValidator', this.checkValidator)
    },
    beforeDestroy() {
        EventBus.$off('MemberWriteDefaultLayoutValidator')
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        setInitData() {
            // 프로필 이미지
            if (this.memberData.hasOwnProperty('memberFile')) {
                this.profile = this.memberData.memberFile.slice();
                this.profile.forEach(file => {
                    file.url = file.org_url;
                    file.name = file.org_name;
                })
                this.parentChange('profile', this.profile);
            }

            // 프로필 소개
            this.mb_introduce = this.memberData.mb_introduce;
            this.parentChange('mb_introduce', this.mb_introduce);

            // 아이디
            this.mb_id = this.memberData.mb_id;
            this.parentChange('mb_id', this.mb_id);
            this.idDoubleCheck = true;
            this.parentChange('idDoubleCheck', this.idDoubleCheck);
            this.idDouble = false;
            this.parentChange('idDouble', this.idDouble);

            // 이름
            this.mb_name = this.memberData.mb_name;
            this.parentChange('mb_name', this.mb_name);

            // 닉네임
            this.mb_nick = this.memberData.mb_nick;
            this.parentChange('mb_nick', this.mb_nick);
            this.nickDoubleCheck = true;
            this.parentChange('nickDoubleCheck', this.nickDoubleCheck);
            this.nickDouble = false;
            this.parentChange('nickDouble', this.nickDouble);

            // 성별
            this.mb_sex = this.memberData.mb_sex;
            this.parentChange('mb_sex', this.mb_sex);

            // 생년월일
            this.mb_birth = this.memberData.mb_birth;
            this.parentChange('mb_birth', this.mb_birth);

            // 나이
            // this.mb_age = this.memberData.mb_age;
            // this.parentChange('mb_age', this.mb_age);

            // 비밀번호
            // this.mb_password = this.memberData.mb_password;
            // this.parentChange('mb_password', this.mb_password);

            // // 수정시 비밀번호 undefined 처리
            // if (util.isEmpty(this.mb_password)) {
            //     this.mb_password = '';
            //     this.parentChange('mb_password', '');
            // }

            // 회원등급
            this.mb_is_testor = this.memberData.mb_is_testor;
            this.parentChange('mb_is_testor', this.mb_is_testor);

            // 키
            this.mb_height = this.memberData.mb_height;
            this.parentChange('mb_height', this.mb_height);

            // 몸무게
            this.mb_weight = this.memberData.mb_weight;
            this.parentChange('mb_weight', this.mb_weight);

            // 선호하는 컬러 (필수)
            this.memberData.Color.forEach(data => {
                this.mb_color.push(data.mb_color);
            })
            this.parentChange('mb_color', this.mb_color);

            // 구매 금액
            this.memberData.PartPrice.forEach(data => {
                let key = data.mb_part;
                this.mb_part[key] = data.mb_price;
            })
            this.parentChange('mb_part', this.mb_part);

            // 어깨 착용감
            this.mb_mat_shoulder = this.memberData.mb_mat_shoulder;
            this.parentChange('mb_mat_shoulder', this.mb_mat_shoulder);

            /*if (this.mb_sex === 1) {
                params.mb_mat_waist = this.mb_mat_top;
                params.mb_mat_thigh = this.mb_mat_bottom;
            } else {
                params.mb_mat_top = this.mb_mat_top;
                params.mb_mat_bottom = this.mb_mat_bottom;
            }*/
            // 허리, 가슴 착용감
            if (this.memberData.mb_sex === 1) {
                this.mb_mat_top = this.memberData.mb_mat_waist;
            } else {
                this.mb_mat_top = this.memberData.mb_mat_top;
            }
            this.parentChange('mb_mat_top', this.mb_mat_top);

            // 배 착용감
            this.mb_mat_middle = this.memberData.mb_mat_middle;
            this.parentChange('mb_mat_middle', this.mb_mat_middle);

            // 피부톤
            this.mb_skin = this.memberData.mb_skin;
            this.parentChange('mb_skin', this.mb_skin);

            // 허벅지, 허리 착용감
            if (this.memberData.mb_sex === 1) {
                this.mb_mat_bottom = this.memberData.mb_mat_thigh;
            } else {
                this.mb_mat_bottom = this.memberData.mb_mat_bottom;
            }
            this.parentChange('mb_mat_bottom', this.mb_mat_bottom);

            // 얼굴형
            this.mb_face = this.memberData.mb_face;
            this.parentChange('mb_face', this.mb_face);

            // 체형
            this.mb_body = this.memberData.mb_body;
            this.parentChange('mb_body', this.mb_body);

            // 직종
            this.mb_job = this.memberData.mb_job;
            this.parentChange('mb_job', this.mb_job);

            // 직종이 기타인 경우 input
            this.mb_job_extra = util.isEmpty(this.memberData.mb_job_extra) ? '' : this.memberData.mb_job_extra
            this.parentChange('mb_job_extra', this.mb_job_extra);

            // 상담 기록
            this.mb_memo = this.memberData.mb_memo;
            this.parentChange('mb_memo', this.mb_memo);

            // 사용자 이용 제한
            if (!util.isEmpty(this.memberData.mr_idx)) {
                this.isStopUser = 1;
            } else if (util.isEmpty(this.memberData.mr_idx)) {
                this.isStopUser = 0;
            }
            this.bodyList = authBodyValues(this.memberData.mb_sex);
            this.$forceUpdate();
        },
        setInitOrderInfoData(){
            // 주문자 명
            this.order_mb_name = this.orderInfoData.mb_name;
            this.parentChange('order_mb_name', this.order_mb_name);

            // 주문자 전화번호
            this.order_mb_hp = this.orderInfoData.mb_hp;
            this.parentChange('order_mb_hp', this.order_mb_hp);
            if(this.order_mb_name !== 'none' && !util.isEmpty(this.order_mb_name ) && !util.isEmpty(this.order_mb_hp)) {
                this.isSetOrderData = true
            }else {
                this.isSetOrderData = false
            }
            this.parentChange('isSetOrderData', this.isSetOrderData);
            this.$forceUpdate();
        },
        changeSex() {
            this.parentChange('mb_sex', this.mb_sex);
            this.bodyList = authBodyValues(this.mb_sex);
            this.mb_body = this.bodyList[0].value;
            this.parentChange('mb_body', this.mb_body);
            this.$forceUpdate();
        },
        hasMemberData() {
            return !util.isEmpty(this.memberData);
        },
        hasMemberOrderInfoData() {
            return !util.isEmpty(this.orderInfoData);
        },
        parentChange(type, value) {
            this.memberWriteSetData(type, value);
            if(type == 'order_mb_hp' || type === 'order_mb_name') {
                this.isSetOrderData = true;
                this.memberWriteSetData('isSetOrderData', this.isSetOrderData);
            }
        },
        initIdCheck(type, value) {
            this.parentChange(type, value);

            if (!util.isEmpty(type)) {
                this.idDoubleCheck = false;
                this.parentChange('idDoubleCheck', this.idDoubleCheck);
                this.idDouble = false;
                this.parentChange('idDouble', this.idDouble);
                this.$validate([`${type}`]);
            }
        },

        initNickCheck(type, value) {
            this.parentChange(type, value);

            if (!util.isEmpty(type)) {
                this.nickDoubleCheck = false;
                this.parentChange('nickDoubleCheck', this.nickDoubleCheck);
                this.nickDouble = false;
                this.parentChange('nickDouble', this.nickDouble);
                this.$validate([`${type}`]);
            }
        },

        hasValue(num) {
            return !util.isEmpty(this.mb_color[num - 1])
        },

        noneColor() {
            if (this.mb_color[1] === '') {
                this.mb_color[2] = ''
                this.mb_color = this.mb_color.slice(0, 1)
            } else if (this.mb_color[1] !== '' && this.mb_color[2] === '') {
                this.mb_color = this.mb_color.slice(0, 2)
            }
            this.parentChange('mb_color', this.mb_color);
        },

        pickedColor(item) {
            return this.mb_color.includes(item.value) ? true : false
        },

        openModal(name) {
            this.$modal.show(name);
        },

        hasQuit() {
            return this.UserInfo.g_idx === 2;
        },

        checkValidator(dataArr) {
            this.$validate(dataArr)
        },

        returnMemberType() {
            return !!util.isEmpty(this.memberData); // memberData가 명시적으로 없을 경우
        },
        submitForm() {
            EventBus.$emit('saveMember');
            // EventBus.$emit('writeMember');
        },
        memberStopAfter() {
            this.isStopUser = 1;
            EventBus.$emit('writeGetMember');
        },

        memberActiveAfter() {
            this.isStopUser = 0;
            EventBus.$emit('writeGetMember');
        },

        isAddFaceFile() {
            return !util.isEmpty(this.memberData.Face);
        },
    },
    watch: {
        'orderInfoData': {
            deep: true,
            handler: function (val, oldVal) {
                if (this.hasMemberOrderInfoData()) {
                    this.setInitOrderInfoData();
                }
            }
        }
    },
}
</script>

<style scoped>

</style>
